import * as React from 'react';
import './CenteredFrame.scss';

export default class  CenteredFrame extends React.Component<any> {
    render() {
        return (
            <div 
                className={this.props.isRelative ? 'relative-frame' : 'absolute-frame'} 
                style={{minHeight: this.props.height}}
            >
                <div className="relative-center" style={{width: this.props.width, minHeight: this.props.height}} >
                    <div className="vertical-center" style={{height: this.props.height, minHeight: this.props.height}}>
                    {this.props.children}
                    </div>
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/CenteredFrame.tsx